/**
 * 차트(recharts) 공유 색 팔레트 — app.css 디자인 토큰을 미러한 리터럴.
 *
 * recharts는 SVG 속성에 CSS 변수(`var(--color-*)`) 대신 실제 색 문자열이 필요해 리터럴로 둔다.
 * app.css의 --success/--warning/--destructive/--primary/--border 토큰을 바꾸면 여기도 함께 갱신한다.
 * 두 차트(trend-chart·board-cards)가 이 한 곳을 공유한다.
 */

/** 판정(verdict)별 색 — 점·셀·범례에 공통 사용. */
export const VERDICT_COLOR: Record<string, string> = {
    적합: '#1f9d57', // ~ --success
    근접: '#c98a00', // ~ --warning
    이탈: '#d8392b', // ~ --destructive
    판정불가: '#8a94a6', // ~ --muted-foreground
    기록: '#2f5fe0', // ~ --primary
}

/** 축·격자·선·기준선 등 차트 UI 색. */
export const CHART_UI = {
    line: '#2f5fe0', // ~ --primary
    grid: '#e5e7eb', // ~ --border
    axis: '#6b7280', // ~ --muted-foreground
    threshold: '#c98a00', // ~ --warning
    neutral: '#8a94a6', // ~ --muted-foreground
}
